

'use strict';
//############# THIS CONTROLLER IS USED FOR BS-SWITCH ###########//
//*******CREATED BY: LAKSHMI B
//*******CREATED DATE: 07/22/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//EXAMPLE
//<input
//bs-switch
//ng-model="isSelected"
//type="checkbox"
//switch-active="{{ isActive }}"
//switch-on-label="{{ onLabel }}"
//switch-off-label="{{ offLabel }}"
//switch-on="{{ on }}"
//switch-off="{{ off }}"
//switch-animate="{{ animate }}"
//switch-size="{{ size }}"
//switch-label="{{ label }}"
//switch-icon="{{ icon }}" >

angular.module('EMR.bsSwitch')
  .controller('SwitchController', function ($scope, $log) {
      $scope.isSelected = true;
      $scope.onLabel = 'Y';
      $scope.offLabel = 'N';
      $scope.isActive = false;
      $scope.size = 'medium';
      $scope.animate = true;     

      $scope.toggleActivation = function () {
          $scope.isActive = !$scope.isActive;
      }
  });

